<template>
  <div class="content" style="background-color: white"  >
    <div>
      <nav class="bar bar-nav">
        <a class="button button-link button-nav pull-left"  @click="gotolast()">
          <span class="icon icon-left"></span>返回
        </a>
      </nav>
    </div>
    <div>
      <div  style="margin-bottom: 10px;margin-top: 2.5rem"  >
        <img  style="height: 100%;width: 100%;"  :src="baseurl + pro.imageUrl"   >
      </div>
      <div >
        <div>
        </div>
        <div class="search-input" style="margin-left: 0.5rem;margin-right: 0.5rem;margin-top: 0.5rem">
          <label class="icon icon-search" for="search"></label>
          <input type="search" id='search'  class="open-popup open-goods" data-popup=".popup-goods" placeholder='输入商品...' readonly unselectable="on"/>
        </div>
      </div>
      <!--<div class="searchbar">-->
      <!--<a class="searchbar-cancel">取消</a>-->
      <!--<div class="search-input">-->
      <!--<label class="icon icon-search" for="search"></label>-->
      <!--<input type="search" id='search'  class="open-popup open-goods" data-popup=".popup-goods" placeholder='输入商品...' readonly unselectable="on"/>-->
      <!--</div>-->
      <!--</div>-->
      <merchdata :merchList="merchandise" :description="$route.query.des" :proo= '$route.params.pro'></merchdata>
      <div v-if="merchandise.length>10" class="button"  @click="loadmore" style="margin-bottom: 5rem">更多...</div>
      <div id="over" style="text-align: center;"></div>
    </div>



  </div>

</template>

<script>
  import $ from 'jquery'
  import {mapGetters} from 'vuex'
  import merchdata from '../finder/components/NewMerchandiseListA.vue'
//  import emkt from '../../emkt.js'
  export default {
    mounted () {
      this.fetchData()
    },
    created () {
    },
    data () {
      return {
        merchandise: [],
        total: 0,
        baseurl: '/emktResources/resocurces/img/promotion/',
        pro: {}
      }
    },
    watch: {
      // 如果路由有变化，会再次执行该方法
      // '$route': 'fetchData'
    },
    components: {
      merchdata
    },
    computed: {
      ...mapGetters([
        'hasLogin'
        // ...
      ])
    },
    methods: {
      fetchData () {
        this.pro.promotionGuid = this.$route.query.promotionGuid
        this.pro.imageUrl = this.$route.query.imageUrl
        this.gcapi('queryMerchandise', {promotionGuid: this.pro.promotionGuid, fromIndex: 0}).then((response) => {
          this.merchandise = response.body.result.merchandiseList
          console.log(response.body.result.merchandiseList)
          this.total = response.body.result.total
        })
      },
      loadmore () {
        var fromindex = this.merchandise.length
        if (fromindex >= this.total) {
          $('.button').remove()
          $('#over').append('已经到底啦！')
          return
        } else {
          var addlist = []
          this.gcapi('queryMerchandise', {promotionGuid: this.pro.promotionGuid, fromIndex: fromindex}).then((response) => {
            addlist = response.body.result.merchandiseList
            for (var i = 0; i < addlist.length; i++) {
              this.merchandise.push(addlist[i])
            }
          })
        }
      },
      tolast () {
        this.$router.go(-1)
      },
      gotolast () {
//        if (this.$route.params.channels) {
//          this.$router.push({name: 'Channel', params: {channel: this.$route.params.channels}})
//        } else {
//          this.$router.push({name: 'home'})
//        }
        this.$router.go(-1)
      }

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .button{
    color: #0a8ddf;
    border: 0rem;
    font-size: 1rem
  }
</style>



// WEBPACK FOOTER //
// ChannelDetails.vue?8ba16f94